var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('data-table',{attrs:{"headers":_vm.headers,"fields":_vm.fields,"items":_vm.requests,"viewAction":'view-service-request',"title":"Service Requests","subTitle":"These residents have submitted service requests from the portal. Please take action.","hideSearch":"true"}})],1)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6ad08f34","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/property/dashboard/ServiceRequests.vue
// module id = vwHQ
// module chunks = 0 1